export default __webpack_public_path__ + "static/media/GR00057-lunch.585fd516.svg";